import {
	missionList,
	missionByID,
	missionCreate,
	missionUpdate,
	missionDestroy,
	missionToggle,
	missionCategoryList,
	missionCategoryCreate,
	missionCategoryUpdate,
	missionCategoryDestroy,
	achievementList,
	achievementByID,
	achievementCreate,
	achievementUpdate,
	achievementDestroy,
	achievementCategoryList,
	achievementCategoryCreate,
	achievementCategoryUpdate,
	achievementCategoryDestroy,
	levelDefinitionList,
	rewardRuleList,
	rewardRuleCreate,
	rewardRuleUpdate,
	rewardRuleDestroy,
	rewardItemList,
	rewardItemCreate,
	rewardItemUpdate,
	rewardItemDestroy,
	redemptionList,
} from '@/services/gamification.service'

export default {
	namespaced: true,
	state: {
		missionList: { meta: { pagination: { total: 0 } } },
		mission: {},
		missionCategoryList: { meta: { pagination: { total: 0 } } },
		achievementList: { meta: { pagination: { total: 0 } } },
		achievement: {},
		achievementCategoryList: { meta: { pagination: { total: 0 } } },
		levelDefinitions: [],
		rewardRuleList: { meta: { pagination: { total: 0 } } },
		rewardItemList: { meta: { pagination: { total: 0 } } },
		rewardItem: {},
		redemptionList: { meta: { pagination: { total: 0 } } },

		listStatus: 'init',
		saveStatus: 'init',
		deleteStatus: 'init',
	},
	getters: {
		getMissionList: s => s.missionList,
		getMission: s => s.mission,
		getMissionCategoryList: s => s.missionCategoryList,
		getAchievementList: s => s.achievementList,
		getAchievement: s => s.achievement,
		getAchievementCategoryList: s => s.achievementCategoryList,
		getLevelDefinitions: s => s.levelDefinitions,
		getRewardRuleList: s => s.rewardRuleList,
		getRewardItemList: s => s.rewardItemList,
		getRewardItem: s => s.rewardItem,
		getRedemptionList: s => s.redemptionList,
		getListStatus: s => s.listStatus,
		getSaveStatus: s => s.saveStatus,
		getDeleteStatus: s => s.deleteStatus,
	},
	mutations: {
		SET_MISSION_LIST(state, val) { state.missionList = val },
		SET_MISSION(state, val) { state.mission = val },
		SET_MISSION_CATEGORY_LIST(state, val) { state.missionCategoryList = val },
		SET_ACHIEVEMENT_LIST(state, val) { state.achievementList = val },
		SET_ACHIEVEMENT(state, val) { state.achievement = val },
		SET_ACHIEVEMENT_CATEGORY_LIST(state, val) { state.achievementCategoryList = val },
		SET_LEVEL_DEFINITIONS(state, val) { state.levelDefinitions = val },
		SET_REWARD_RULE_LIST(state, val) { state.rewardRuleList = val },
		SET_REWARD_ITEM_LIST(state, val) { state.rewardItemList = val },
		SET_REWARD_ITEM(state, val) { state.rewardItem = val },
		SET_REDEMPTION_LIST(state, val) { state.redemptionList = val },
		SET_LIST_STATUS(state, val) { state.listStatus = val },
		SET_SAVE_STATUS(state, val) { state.saveStatus = val },
		SET_DELETE_STATUS(state, val) { state.deleteStatus = val },
	},
	actions: {
		// ─── Missions ───────────────────────────────────
		async fetchMissionList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			commit('SET_MISSION_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await missionList(params)
				commit('SET_MISSION_LIST', data)
				commit('SET_LIST_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_LIST_STATUS', 'init')
				throw e
			}
		},
		async fetchMissionByID({ commit }, id) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await missionByID(id)
				commit('SET_MISSION', data.data)
				commit('SET_LIST_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_LIST_STATUS', 'init')
				throw e
			}
		},
		async saveMission({ commit }, params) {
			commit('SET_SAVE_STATUS', 'pending')
			try {
				const { data } = params.id ? await missionUpdate(params) : await missionCreate(params)
				commit('SET_SAVE_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_SAVE_STATUS', 'init')
				throw e
			}
		},
		async deleteMission({ commit }, params) {
			commit('SET_DELETE_STATUS', 'pending')
			try {
				const { data } = await missionDestroy(params)
				commit('SET_DELETE_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_DELETE_STATUS', 'init')
				throw e
			}
		},
		async toggleMission(_, id) {
			return missionToggle(id)
		},

		// ─── Mission Categories ─────────────────────────
		async fetchMissionCategoryList({ commit }, params) {
			try {
				const { data } = await missionCategoryList(params)
				commit('SET_MISSION_CATEGORY_LIST', data)
				return data
			} catch (e) { throw e }
		},
		async saveMissionCategory({ commit }, params) {
			commit('SET_SAVE_STATUS', 'pending')
			try {
				const { data } = params.id ? await missionCategoryUpdate(params) : await missionCategoryCreate(params)
				commit('SET_SAVE_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_SAVE_STATUS', 'init')
				throw e
			}
		},
		async deleteMissionCategory({ commit }, params) {
			commit('SET_DELETE_STATUS', 'pending')
			try {
				await missionCategoryDestroy(params)
				commit('SET_DELETE_STATUS', 'init')
			} catch (e) {
				commit('SET_DELETE_STATUS', 'init')
				throw e
			}
		},

		// ─── Achievements ───────────────────────────────
		async fetchAchievementList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			commit('SET_ACHIEVEMENT_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await achievementList(params)
				commit('SET_ACHIEVEMENT_LIST', data)
				commit('SET_LIST_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_LIST_STATUS', 'init')
				throw e
			}
		},
		async fetchAchievementByID({ commit }, id) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await achievementByID(id)
				commit('SET_ACHIEVEMENT', data.data)
				commit('SET_LIST_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_LIST_STATUS', 'init')
				throw e
			}
		},
		async saveAchievement({ commit }, params) {
			commit('SET_SAVE_STATUS', 'pending')
			try {
				const { data } = params.id ? await achievementUpdate(params) : await achievementCreate(params)
				commit('SET_SAVE_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_SAVE_STATUS', 'init')
				throw e
			}
		},
		async deleteAchievement({ commit }, params) {
			commit('SET_DELETE_STATUS', 'pending')
			try {
				await achievementDestroy(params)
				commit('SET_DELETE_STATUS', 'init')
			} catch (e) {
				commit('SET_DELETE_STATUS', 'init')
				throw e
			}
		},

		// ─── Achievement Categories ─────────────────────
		async fetchAchievementCategoryList({ commit }, params) {
			try {
				const { data } = await achievementCategoryList(params)
				commit('SET_ACHIEVEMENT_CATEGORY_LIST', data)
				return data
			} catch (e) { throw e }
		},
		async saveAchievementCategory({ commit }, params) {
			commit('SET_SAVE_STATUS', 'pending')
			try {
				const { data } = params.id ? await achievementCategoryUpdate(params) : await achievementCategoryCreate(params)
				commit('SET_SAVE_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_SAVE_STATUS', 'init')
				throw e
			}
		},
		async deleteAchievementCategory({ commit }, params) {
			commit('SET_DELETE_STATUS', 'pending')
			try {
				await achievementCategoryDestroy(params)
				commit('SET_DELETE_STATUS', 'init')
			} catch (e) {
				commit('SET_DELETE_STATUS', 'init')
				throw e
			}
		},

		// ─── Level Definitions ──────────────────────────
		async fetchLevelDefinitions({ commit }) {
			try {
				const { data } = await levelDefinitionList()
				commit('SET_LEVEL_DEFINITIONS', data.data ?? [])
				return data
			} catch (e) { throw e }
		},

		// ─── Reward Rules ───────────────────────────────
		async fetchRewardRuleList({ commit }, params) {
			try {
				const { data } = await rewardRuleList(params)
				commit('SET_REWARD_RULE_LIST', data)
				return data
			} catch (e) { throw e }
		},
		async saveRewardRule({ commit }, params) {
			commit('SET_SAVE_STATUS', 'pending')
			try {
				const { data } = params.id ? await rewardRuleUpdate(params) : await rewardRuleCreate(params)
				commit('SET_SAVE_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_SAVE_STATUS', 'init')
				throw e
			}
		},
		async deleteRewardRule({ commit }, params) {
			commit('SET_DELETE_STATUS', 'pending')
			try {
				await rewardRuleDestroy(params)
				commit('SET_DELETE_STATUS', 'init')
			} catch (e) {
				commit('SET_DELETE_STATUS', 'init')
				throw e
			}
		},

		// ─── Reward Items ───────────────────────────────
		async fetchRewardItemList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			commit('SET_REWARD_ITEM_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await rewardItemList(params)
				commit('SET_REWARD_ITEM_LIST', data)
				commit('SET_LIST_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_LIST_STATUS', 'init')
				throw e
			}
		},
		async saveRewardItem({ commit }, params) {
			commit('SET_SAVE_STATUS', 'pending')
			try {
				const { data } = params.id ? await rewardItemUpdate(params) : await rewardItemCreate(params)
				commit('SET_SAVE_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_SAVE_STATUS', 'init')
				throw e
			}
		},
		async deleteRewardItem({ commit }, params) {
			commit('SET_DELETE_STATUS', 'pending')
			try {
				await rewardItemDestroy(params)
				commit('SET_DELETE_STATUS', 'init')
			} catch (e) {
				commit('SET_DELETE_STATUS', 'init')
				throw e
			}
		},

		// ─── Redemptions ────────────────────────────────
		async fetchRedemptionList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			commit('SET_REDEMPTION_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await redemptionList(params)
				commit('SET_REDEMPTION_LIST', data)
				commit('SET_LIST_STATUS', 'init')
				return data
			} catch (e) {
				commit('SET_LIST_STATUS', 'init')
				throw e
			}
		},
	},
}
